import { useState } from "react";
import { useTranslation } from "react-i18next";
import { Snackbar } from "@material-ui/core";
import { Alert } from "@material-ui/lab";

import uiConf from "../../config/uiConf";

import Dialog from "../dialog/functional/Dialog";
import DialogHeader from "../dialog/functional/DialogHeader";
import DialogHeaderWithClose from "../dialog/functional/DialogHeaderWithClose";
import DialogTitle from "../dialog/functional/DialogTitle";
import DialogContent from "../dialog/functional/DialogContent";
import DialogActionsOk from "../dialog/functional/DialogActionsOk";

import MomSysBomBopTree from "../screens/MomSysBomBopTree";

function MomSysBomBopTreeDialog ( props ) {

    const { t } = useTranslation();

    const {

        id,
        product,

        moveable,
        resizable,
        fullWidth,
        maxWidth,

        onInitialized,

        ...others

    } = props;

    const [, setInstance] = useState ();
    const [notification, setNotification] = useState({
        open: false,
        severity: "success",
        msg: "",
    });

    const onDialogInitialized = ( instance ) => {

        setInstance ( instance );

        if ( onInitialized ) {

            onInitialized ( instance );
            
        }

    };

    const onCloseNotification = () => {

        setNotification((notification) => {

            return ({ ...notification, open: false });

        });

    };

    const onError = ( reason ) => {

        setNotification({
            severity: "error",
            msg: reason.response ? reason.response.data : reason,
            open: true,
        });

    };

    return (
        <Dialog
            id={id}
            title={t("dialog.title.MomSysBomBopTree")}
            moveable={moveable ? moveable : uiConf.dialogMoveable}
            resizable={resizable ? resizable : uiConf.dialogResizable}
            fullWidth={fullWidth ? fullWidth : uiConf.dialogFullWidth}
            maxWidth="md"
            onInitialized={onDialogInitialized}
            {...others}
        >

            {uiConf.modalWithCloseButton ? (
                <DialogHeaderWithClose>
                    <DialogTitle>
                        {t("dialog.title.MomSysBomBopTree")}
                    </DialogTitle>
                </DialogHeaderWithClose>
            ) : (
                <DialogHeader>
                    <DialogTitle>
                        {t("dialog.title.MomSysBomBopTree")}
                    </DialogTitle>
                </DialogHeader>
            )}

            <DialogContent style={{height: "400px"}} dividers >
                <MomSysBomBopTree product={product} onError={onError} />
            </DialogContent>

            <Snackbar
                open={notification.open && notification.severity !== "success"}
                autoHideDuration={uiConf.dialogNotifyAutoHideDuration}
                onClose={onCloseNotification}
            >
                <Alert
                    onClose={onCloseNotification}
                    variant="filled"
                    severity={notification.severity}
                >
                    {notification.msg}
                </Alert>
            </Snackbar>

            <DialogActionsOk close />

        </Dialog>
    );

}

export default MomSysBomBopTreeDialog;
